<div class="full-page login-page w-100">
  <div class="container login-container">
    <div class="d-none d-lg-flex">
      <img [src]="'logos/logo.svg' | contentAssetImage" alt="" class="fortress-logo" />
    </div>
    <div class="login-mobile-logo d-flex d-lg-none justify-content-center">
      <img [src]="'logos/logo.svg' | contentAssetImage" alt="OKC Thunder" class="okc-logo" />
    </div>
    <div class="login-card bg-white text-start">
      <h3 class="login-title font-heading text-primary text-uppercase mb-0">{{ 'login.page.title' | translate }}</h3>
      <p class="login-description font-size-14 mb-0">{{ 'login.page.description' | translate }}</p>
      <fgb-tm-user-login></fgb-tm-user-login>
      <!-- <a
        [routerLink]="['/register/new-member']"
        class="btn btn-primary create-account-button w-100 d-flex align-items-center justify-content-center fw-bold font-size-14"
      >
        <span class="text-white">{{ 'login.page.create.account.button' | translate }}</span>
        <img [src]="'providers/ticketmaster' | contentAssetImage" alt="Ticketmaster" class="tm-logo-btn ms-2" />
      </a> -->
    </div>
  </div>
</div>
